const LoginCodeList = [
  // {
  //   title: "验证码登录",
  //   BorderRadius: "8px 0px 0px 0px",
  //   state: 0,
  // },
  {
    title: "账号密码登录",
    BorderRadius: "0px 8px 0px 0px",
    state: 1,
  },
];
export default LoginCodeList;
